import { ReactNode, createContext, useContext } from 'react';

// stores
import { initialAuthContext } from '@/stores/authContext';
import type { AuthContextType } from '@/stores/authContext';

import { useCognito } from './useCognito';

export const AuthContext = createContext<AuthContextType>(initialAuthContext());

type signInType = (user: AuthContextType) => void;

interface Props {
  children?: ReactNode;
  onSignIn?: signInType[];
}

export function AuthProvider(props: Props) {
  const auth = useCognito();
  return <AuthContext.Provider value={auth}>{props.children}</AuthContext.Provider>;
}

// eslint-disable-next-line react-refresh/only-export-components
export const useAuth = () => {
  return useContext(AuthContext);
};
